import {
  getAttributionCode,
  rememberSession,
  request,
} from "@/lib/api";

const RETRYABLE_CLAIM_REASONS = new Set([
  "binding_circuit_open",
  "capacity",
  "pool_cold",
]);

export function isRetryableLandingInstantLinkClaimError(error) {
  const status = Number(error?.status);
  const reason = String(error?.message || "").trim().toLowerCase();
  if (!Number.isFinite(status)) return true;
  if (status >= 500 || status === 425 || status === 429) return true;
  return status === 409 && RETRYABLE_CLAIM_REASONS.has(reason);
}

export async function claimLandingInstantLink() {
  const payload = await request("/api/landing-link-claims", {
    method: "POST",
    body: JSON.stringify({ attributionCode: getAttributionCode() }),
    allowAnonymousBootstrap: true,
  });
  rememberSession(payload);
  return payload;
}

export async function loadLandingInstantQr(
  linkSessionId,
  { expectedGeneration = null, phase = "current" } = {},
) {
  const normalizedLinkSessionId = String(linkSessionId || "").trim();
  if (!normalizedLinkSessionId) {
    throw new Error("Missing link session.");
  }
  const query = new URLSearchParams({ phase });
  if (Number.isInteger(expectedGeneration) && expectedGeneration >= 0) {
    query.set("expectedGeneration", String(expectedGeneration));
  }
  return request(
    `/api/landing-link-claims/${encodeURIComponent(normalizedLinkSessionId)}/qr?${query.toString()}`,
    { allowAnonymousBootstrap: true, forceFresh: true },
  );
}
